






import {Component, Vue} from "vue-property-decorator";

import {Store} from "@/enums/Store";

import {Event} from "@/util/Event";

import {namespace} from 'vuex-class';

const EVENT = namespace(Store.EVENT);

@Component({})
export default class EventOverview extends Vue {
  @EVENT.Getter('selectedEventObject') event!:Event;
}
